// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export default class UnifiedSignupUtil {
  public static isForcedScreenEnabled(): boolean {
    return !!UnifiedSignupUtil.getForcedScreenOrNull();
  }

  /**
   * Get the value to `forceScreen` for debugging. This will allow the dev to
   * show a screen after filling out the first first/last/email values
   * */
  public static getForcedScreenOrNull(): string | null {
    try {
      const here = new URL(document.location.href);
      const forcedScreen = here.searchParams.get('forceScreen');
      if (forcedScreen) {
        console.log(`Forced screen ${forcedScreen}`);
      }
      return forcedScreen || null;
    } catch {
      return null;
    }
  }

  /** Used to force an email check code */
  public static getForcedEmailCheckCodeOrNull(): number | null {
    try {
      const here = new URL(document.location.href);
      const code = here.searchParams.get('forceEmailCheckCode') || null;
      if (code === null) return null;
      const emailCheckCode = parseInt(code, 10);

      console.log(`Url has emailCheckCode: value: ${emailCheckCode}`);
      return emailCheckCode;
    } catch {
      return null;
    }
  }
}
